<template>
  <div class="container register">
    <v-card class="mt-12 mx-auto" width="70%">
      <v-card-title
        class="mt-12 text-center loginmain justify-center text-white"
        style="font-size:26px; font-family: 'Nunito', sans-serif;"
      >Forgot Password</v-card-title>

      <v-card-text class="mt-8 text-center">Enter Your Registered Mobile Number Below</v-card-text>

      <div class="text-center">
        <v-text-field
          outlined
          class="mb-3 mobilenumber"
          prepend-icon="mdi-cellphone"
          label=" Enter Reg Mobile Number "
          v-model="mnumber"
          type="number"
        />
        <div class="mb-8 justify-center form-inline">
          <span>The password will be sent to your registered mobile number</span>
          <v-btn color="primary" class="mt-1" small text>Resend</v-btn>
        </div>

        <v-btn color="primary" class="mb-12 submit" @click="handleClick">
          <v-icon>mdi-telegram</v-icon>Send
        </v-btn>
        <v-btn color="primary" class="ml-2 mb-12 mr-2 submit"  @click="goTo('/login')">
          <v-icon>mdi-keyboard-backspace</v-icon>Login 
        </v-btn>
      </div>
    </v-card>
  </div>
</template>
<script>
import { forgotPassword } from '../../services/user';

export default {
  data() {
    return {
      mnumber: "",
      dialog: false
    };
  },
  methods: {
    async handleClick() {
      try {
        const result = await forgotPassword(this.mnumber);
        console.log('got result : ', result);
        this.$toasted.success('Your password has been sent to your mobile', {
                duration: 3000
              })
      }
      catch(err) {
        console.log(err);
        this.$showError('Something went wrong');
      }
    },
    goTo(path,params){
      this.$router.push({
        path,
        params,
      });

    }
  },
};
</script>
<style scoped>
.register {
  background-image: url("/img/authentication.jpg");
  background-size: cover;
  background-position: center;
  max-width: 100%;
  height: 100% !important;
}
.submit {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}
</style>
<style>
.mobilenumber {
  margin-left: 10rem !important;
  margin-right: 10rem !important;
}
@media (max-width: 768px) {
  .mobilenumber {
    margin-left: 30px !important;
    margin-right: 30px !important;
  }
}
</style>